import { createSelector } from "reselect";
import { RootState } from "common";

const selectUserAddress = (state: RootState) => state.PcwUserAddress;

const selectUserAddressDetail = createSelector(
  selectUserAddress,
  (state) => state?.userAddressDetailState
);

const selectUserAddressList = createSelector(
  selectUserAddress,
  (state) => state?.userAddressListState
);

export const selectors = {
  selectUserAddressDetail,
  selectUserAddressList,
};
